import { Box } from '@chakra-ui/react';
import NiceModal from '@ebay/nice-modal-react';

import IconHover from './IconHover';
import AlertModal from './modals/AlertModal';

export enum FILE_TYPES {
  PDF = 'application/pdf',
  JPG = 'image/jpeg',
  PNG = 'image/png',
}

export const RenderFile = (props: { encodedFile: string; type: string; header: string }) => {
  const { encodedFile, type = FILE_TYPES.JPG, header } = props;

  if (!encodedFile) {
    return null;
  }

  let preview = (
    <object
      data={`data:${type};base64,${encodedFile}`}
      type={type}
      style={{ width: '100%', height: '100%', aspectRatio: '16 / 10', objectFit: 'cover' }}
      aria-label={header}
    />
  );

  let content = (
    <object
      data={`data:${type};base64,${encodedFile}`}
      type={type}
      style={{
        width: '100%',
        height: 'auto',
        aspectRatio: '16 / 9',
        objectFit: 'contain',
      }}
      aria-label={header}
    />
  );

  return (
    <>
      <Box role="group" sx={{ position: 'relative' }}>
        <Box>{preview}</Box>
        <Box
          onClick={() =>
            NiceModal.show(AlertModal as any, {
              children: content,
              styleConfig: {
                maxW: { base: '90%', lg: '80%' },
              },
              content: {
                hide: true,
                footer: {
                  buttons: {
                    hide: true,
                  },
                },
              },
            })
          }
        >
          <IconHover />
        </Box>
      </Box>
    </>
  );
};
